import React, { useRef, useState, useEffect } from 'react';
import { Tooltip, Box, Typography, Container, Button, Grid, AppBar, Toolbar, useTheme, useMediaQuery, CardContent, ThemeProvider, createTheme, Card, Snackbar, CardMedia } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import Logo from '../Logo/Dark/Full - Copy/1Asset 17@72x-8.png';
import Header from '../Header/Header';
import Header1 from '../Header/Header1';
import Header2 from '../Header/Header2';
import Footer from '../Footer/Footer';
import Teach from '../Icon/Teach.png';
import Learn from '../Icon/Learn4.png';
import Monetize from '../Icon/Monitize2.png';
import Growth from '../Icon/Growth.png';
import Announcement from '../Icon/Announce3.png';
import Collaborative from '../Icon/Collaborate2.png';
import Creative from '../Icon/Creative.png';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
import Real_world from '../Icon/Real_world.png';
import Practical_skill from '../Icon/Practical_skill.png';
import Learning from '../Icon/Learning.png';
import Time from '../Icon/Time.png';
import VisionBackground from '../Icon/Vission_latest.png';
import MissionBackground from '../Icon/mi1.png';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { IconButton } from '@mui/material';
import { FaCogs, FaDiscord } from 'react-icons/fa';
import { motion } from 'framer-motion';  // For animations
import { AiOutlineRobot } from 'react-icons/ai';
import { FaBrain, FaAndroid } from 'react-icons/fa';
import {
    Language, Lock, LockOpen, Lightbulb, Handshake, Settings, Share, Verified, Chat, AccessTime,
    Public, AccountCircle, ShoppingCart, Star, PhoneAndroid, School, MonetizationOn, Group,
    TrendingUp, DeviceHub, Dashboard, Article, LibraryBooks, Assistant, Close as CloseIcon
} from '@mui/icons-material';
import DemoVideoSection from './DemoVideoSection';
import DemoVideoSection2 from './DemoVideoSection2';
import DemoVideoSection3 from './DemoVideoSection3';
import UserGuide from './UserGuide1.jpg'
import TimeToGrowAnimation from './TimeToGrowAnimation';
import NewsSection from '../News/NewsSection';
import { Global } from '@emotion/react';
import KnowledgeExchange from './KnowledgeExchange';
import PaymentSecurityBanner from './PaymentSecurityBanner';
import MeetingPlatforms from './MeetingPlatforms';
import GDPRCompliance from './GDPRCompliance';
import MultilingualSupport from './MultilingualSupport';
import SafeVerificationSystem from './SafeVerificationSystem';
import KnowledgeExchangeFields from './KnowledgeExchangeFields';
import BuiltWithTech from './BuiltWithTech';
import FuturePage from './FuturePage';
import JourneyPage from './JourneyPage';
import JoinUsSection from './JoinUsSection';
import SocialMediaSection from './SocialMediaSection';
import KnowledgeExchangeSection from './KnowledgeExchangeSection';
import DemoSection from './DemoSection';
import MotivationalMessage from './MotivationalMessage';
import RequestMotivation from './RequestMotivation';
import ExpertSessionMotivation from './ExpertSessionMotivation';
import UseCaseSlider from './UseCaseSlider';
import CustomerSupportSection from './CustomerSupportSection';
import KnowledgeGrowthSection from './KnowledgeGrowthSection';
import QuoteContainer from './QuoteContainer';
import NewsletterSection from './NewsletterSection';
import FarmerUseCase from './FarmerUseCase';
import EducationUseCase from './EducationUseCase';
import MentalHealthMessage from './MentalHealthMessage';
import AnimatedLogo from '../AnimatedLogo/AnimatedLogo';
import ProjectVishwamitra from './ProjectVishwamitra';
import VerifiedUsersDiagram from './VerifiedUsersDiagram';
import ProjectAISync from '../AI Sync/ProjectAISync';
import Spline from '@splinetool/react-spline';



const API_URL = process.env.REACT_APP_API_URL;



function Home({ userId, loggedIn, onLogout }) {

    useEffect(() => {
        window.scrollTo(0, 0);  // Scroll to top when this page is loaded
    }, []);

    const logoIconRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0); // State to track the active box





    const features1 = [
        {
            title: 'Unique',
            description: 'Our platform is completely unique.',
            icon: <Assistant />,
        },
        {
            title: 'Easy',
            description: 'Designed with simplicity in mind for a seamless experience.',
            icon: <Settings />,
        },
        {
            title: 'Safe',
            description: 'Top-notch security measures to keep your data safe and private.',
            icon: <Lock />,
        },
        {
            title: 'Multilingual',
            description: 'Supports multiple languages, breaking barriers.',
            icon: <Language />,
        },
        {
            title: '3As',
            description: 'Anyone can access the platform from anywhere, at any time, on any device.',
            icon: <Public />,
        },


        {
            title: 'No Limits',
            description: 'Share and access knowledge without restrictions.',
            icon: <Lightbulb />,
        },
        {
            title: 'All',
            description: 'Our platform is accessible and inclusive for everyone.',
            icon: <Handshake />,
        },

        {
            title: 'Freedom',
            description: 'Take control of your experience with personalized options.',
            icon: <LockOpen />,
        },

        {
            title: 'Verification',
            description: 'Ensure trust and authenticity with reliable verification methods.',
            icon: <Verified />,
        },
        {
            title: 'Connect',
            description: 'Find and engage with others who share your interests and goals.',
            icon: <Chat />,
        },
        {
            title: 'Save',
            description: 'Efficient solutions that help you make the most of your time and resources.',
            icon: <AccessTime />,
        },
        {
            title: 'Learn',
            description: 'Use our platform to expand your skills at your own pace.',
            icon: <School />,
        },
        {
            title: 'Share',
            description: 'Share your experiences, knowledge, and content.',
            icon: <Share />,
        },

        {
            title: 'ML-Powered',
            description: 'ML algorithms deliver personalized recommendations.',
            icon: <Dashboard />,
        },

        {
            title: 'Data Visuals',
            description: 'Interactive and insightful data visuals that help you in understanding.',
            icon: <TrendingUp />,
        },

        {
            title: 'Secure',
            description: 'Reliable and encrypted payment options for safe and smooth transactions.',
            icon: <LibraryBooks />,
        },
        {
            title: 'Ratings',
            description: 'Empowering users to provide feedback to help maintain quality and trust.',
            icon: <Star />,
        },
        {
            title: 'Compatible',
            description: 'No matter which device you use, our platform works seamlessly.',
            icon: <PhoneAndroid />,
        },
        {
            title: 'Support',
            description: 'Experience exceptional customer support with to resolve your issues.',
            icon: <Assistant />,
        },
        {
            title: 'Upgradation',
            description: 'Upgrade your access and features based on your usage.',
            icon: <TrendingUp />,
        },

        {
            title: 'One-Stop',
            description: 'Access all your knowledge needs in one place, with ease.',
            icon: <ShoppingCart />,
        },



    ];



    // Dark Theme Configuration
    const darkTheme = createTheme({
        palette: {
            mode: 'dark', // Set the theme to dark
            primary: {
                main: '#90caf9', // Light blue for primary color
            },
            background: {
                default: '#121212', // Dark background color
                paper: '#1e1e1e', // Card background
            },
            text: {
                primary: '#fff', // White text on dark background
                secondary: '#b0b0b0', // Light gray text for secondary content
            },
        },
        typography: {
            h6: {
                fontWeight: 600,
            },
            body2: {
                color: '#b0b0b0', // Light gray text for body text
            },
        },
    });




    // Your Discord invite URL (replace with your actual invite link)
    const discordInviteURL = 'https://discord.gg/9PFJf4gBJ8';

    const announcements = [
        {
            title: 'Major Update',
            message: 'The platform just got a major update.',
            fullMessage: 'We’ve improved the UI for a cleaner look, added new features to enhance functionality, and boosted overall performance for a smoother experience.',
            link: '#'
        },
        {
            title: 'Scheduled Maintenance',
            message: 'The website will be under maintenance every Sunday at 1 AM IST.',
            fullMessage: 'During this period, all services will be temporarily unavailable. We expect the maintenance to take around 2 hours.',
            link: '#'
        },
        {
            title: 'Hiring Update',
            message: 'The careers page is live now.',
            fullMessage: 'All the interested people can apply for various roles based on your interests and availability.',
            link: '#'
        }
    ];

    const [expandedIndex, setExpandedIndex] = useState(null); // Track which card is expanded

    const handleToggleExpand = (index) => {
        // Toggle expand state for the clicked card
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    const [open, setOpen] = useState(true);

    const handleClose = () => setOpen(false);


    const scrollToSection = (id) => {
        document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
    };


    const navigate = useNavigate(); // Initialize navigate

    const handleLearnMoreClick = () => {
        navigate('/home'); // Replace '/content' with the path to your content page
    };


    useEffect(() => {
        // Add animation logic here if needed
    }, []);

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1, // Show one box at a time
        slidesToScroll: 1,
        arrows: false, // You can set to true if you want navigation arrows
        afterChange: (current) => {
        },
        // Add custom CSS for the 'floating wave' effect
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const features = [
        {
            title: 'Teach',
            description: "Teaching what you are passionate about in language of your choice can be incredibly rewarding.",
            image: Teach,
        },
        {
            title: 'Learn',
            description: "Learn what you want in language of your choice at your own pace and time.",
            image: Learn,
        },
        {
            title: 'Monetize',
            description: "Monetizing your knowledge can open up new doors of opportunities and enable financial freedom.",
            image: Monetize,
        },
        {
            title: 'Connect',
            description: "You can connect with like-minded individuals based on your interests, hence become part of thriving community.",
            image: Collaborative,
        },
        {
            title: 'Grow',
            description: "Sharing your knowledge helps others and reinforces your own understanding.",
            image: Growth,
        },
        {
            title: 'Crucial Learning',
            description: "Learning through hands-on experiences and real-life examples is crucial for personal growth.",
            image: Creative,
        },]

    const benefits = [
        {
            title: "Real-World Info",
            description: "Learn from people who have hands-on experience, not just theoretical knowledge.",
            image: Real_world, // Add an image for each benefit
        },
        {
            title: "Utilise Time",
            description: "Direct mentorship and personalised learning paths eliminate unnecessary internet searching.",
            image: Time,
        },
        {
            title: "Be Practical",
            description: "Focussing on what works in the real world, makes you more capable in your field.",
            image: Practical_skill,
        },
        {
            title: "Passion-Driven",
            description: "Bring your passion to life. As a passionate educator you can offer more engaging and valuable sessions.",
            image: Learning,
        },
    ];

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        appendDots: dots => (
            <div
                style={{
                    position: 'absolute',
                    bottom: window.innerWidth < 600 ? '-20px' : window.innerWidth < 960 ? '-25px' : '-30px',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <ul style={{
                    margin: '0px',
                    padding: '0px',
                    display: 'flex',
                    gap: window.innerWidth < 600 ? '1px' : '5px' // Smaller gap for small screens
                }}>
                    {dots}
                </ul>
            </div>
        ),

        customPaging: () => (
            <div
                style={{
                    width: '12px',
                    height: '12px',
                    borderRadius: '50%',
                    backgroundColor: 'white',
                    opacity: 0.5,
                }}
            />
        )
    };

    return (
        <div style={{ backgroundColor: "black" }}>
            {/* Conditional rendering of Header or Header1 */}
            {loggedIn ? (
                <Header1 style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', alignItems: 'center' }} userId={userId} onLogout={onLogout} />
            ) : (
                <Header style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', alignItems: 'center' }} />
            )}
            <div style={{
                backgroundColor: 'black',
                height: '100%',
                position: 'fixed',
                width: '100%',
                zIndex: -1,
            }}></div>
<Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        height: '100%',
        width: '100%',
        position: 'absolute', // Ensures full coverage inside root
        top: 0,
        left: 0,
      }}
    >
      <Box sx={{ flexGrow: 1, position: 'relative' }}>
        <Spline
          scene="https://prod.spline.design/x7bmDa8-mtiHKsnD/scene.splinecode"
          style={{ width: '100%', height: '100%' }}
        />
      </Box>
    </Box>

            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                    height: {
                        xs: '60vh',
                        sm: '80vh',
                        md: '90vh',
                        lg: '90vh',
                        xl: '60vh',
                    },
                    position: 'relative',
                    zIndex: 1,
                    textAlign: 'center',
                    overflow: 'hidden',

                }}
            >
                <Box
                    ref={logoIconRef}
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: {
                            xs: '80%',
                            sm: '70%',
                            md: '60%',
                        },
                        maxHeight: '80%',
                        height: 'auto',
                        opacity: 1,
                        transition: 'opacity 0.5s ease, box-shadow 0.3s ease',
                        zIndex: 2,
                        // boxShadow: '0 0 15px 5px #1E90FF', 
                        borderRadius: '50px', // Increased curvature
                        overflow: 'hidden', // Ensures the video fits the border radius
                        '&:hover': {
                            boxShadow: '0 0 20px 7px #1E90FF', // Blue glow on hover
                        },
                    }}
                >
                    <AnimatedLogo />


                </Box>


            </Box>

             <ThemeProvider theme={darkTheme}>
      {/* Scroll Keyframes */}
      <Global
        styles={{
          '@keyframes scrollLeft': {
            '0%': { transform: 'translateX(0)' },
            '100%': { transform: 'translateX(-50%)' },
          },
        }}
      />

      <Box
        id="glimpse"
        sx={{
          flexGrow: 1,
          py: { xs: 4, sm: 6 },
          px: { xs: 2, sm: 5 },
          backgroundColor: '#000',
          overflow: 'hidden',
        }}
      >
        {/* Heading */}
        {/* <Typography
          variant="h5"
          component="h1"
          sx={{
            fontWeight: 600,
            textAlign: 'center',
            fontSize: { xs: '1.4rem', sm: '1.8rem' },
            letterSpacing: 6,
            marginBottom: '20px',
            background: 'linear-gradient(90deg, #1E90FF, #FF1493)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            animation: 'glowText 6s linear infinite',
            '@keyframes glowText': {
              '0%': { backgroundPosition: '0% 50%' },
              '50%': { backgroundPosition: '100% 50%' },
              '100%': { backgroundPosition: '0% 50%' },
            },
            backgroundSize: '200% 200%',
          }}
        >
          Connecting people who need knowledge with those who have it—in real time.
        </Typography> */}

        {/* Marquee Box */}
        <Box
          sx={{
            display: 'flex',
            whiteSpace: 'nowrap',
            width: 'fit-content',
            animation: {
              xs: 'scrollLeft 45s linear infinite',
              sm: 'scrollLeft 45s linear infinite',
              md: 'scrollLeft 70s linear infinite',
            },
            gap: 3,
            pl: 2,
          }}
        >
          {[...features1, ...features1].map((feature, index) => (
            <Box
              key={index}
              sx={{
                display: 'inline-block',
                minWidth: { xs: 280, sm: 360, md: 400 },
                height: 200,
                padding: 3,
                borderRadius: '20px',
                background: 'rgba(255, 255, 255, 0.05)',
                border: '1px solid rgba(255,255,255,0.1)',
                backdropFilter: 'blur(12px)',
                boxShadow: '0px 8px 30px rgba(0, 0, 0, 0.6)',
                textAlign: 'center',
                transition: 'transform 0.4s ease, box-shadow 0.4s ease, border 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-10px)',
                  borderColor: '#1E90FF',
                  boxShadow: '0px 14px 45px rgba(30, 144, 255, 0.4)',
                },
              }}
            >
              <CardContent>
                <Typography variant="h4" sx={{ color: '#1E90FF', mb: 1 }}>
                  {feature.icon}
                </Typography>

                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    fontSize: '1.1rem',
                    letterSpacing: 1.5,
                    color: 'white',
                    mb: 1,
                    '&:hover': { color: '#1E90FF' },
                  }}
                >
                  {feature.title}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    fontSize: '0.9rem',
                    color: '#ccc',
                    letterSpacing: 1,
                    lineHeight: 1.5,
                    whiteSpace: 'normal',
                    overflowWrap: 'break-word',
                  }}
                >
                  {feature.description}
                </Typography>
              </CardContent>
            </Box>
          ))}
        </Box>
      </Box>
    </ThemeProvider>
    

            <UseCaseSlider />
            <MotivationalMessage />
            {/* <RequestMotivation /> */}
            {/* <ExpertSessionMotivation /> */}
            <KnowledgeExchangeFields />
            {/* <SafeVerificationSystem /> */}
            {/* <MeetingPlatforms /> */}
            <GDPRCompliance />

            <BuiltWithTech />
           <Box
      id="ai"
      sx={{
        backgroundColor: '#000',
        padding: theme.spacing(8, 3),
        borderRadius: '20px',
        color: '#fff',
        boxShadow: '0px 10px 40px rgba(0,0,0,0.6)',
        mt: 10,
        mb: 10,
        overflow: 'hidden',
      }}
    >
      {/* Heading */}
      <motion.div
        initial={{ opacity: 0, y: -40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            textAlign: 'center',
            fontSize: { xs: '2rem', md: '3rem' },
            letterSpacing: 3,
            mb: 2,
            color: '#ffffff',
            textTransform: 'uppercase',
          }}
        >
          AI SYNC
        </Typography>
      </motion.div>

      {/* Subheading */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 400,
            textAlign: 'center',
            fontSize: '1.4rem',
            color: '#bbbbbb',
            mb: 5,
            letterSpacing: 2,
          }}
        >
          Experience AI Like Never Before
        </Typography>
      </motion.div>

      {/* Grid Section */}
      <Grid container spacing={6} justifyContent="center">
        {/* Generative AI */}
        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9 }}
            viewport={{ once: true }}
          >
            <Box
              sx={{
                background: 'rgba(255, 255, 255, 0.04)',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: '16px',
                padding: theme.spacing(5),
                textAlign: 'center',
                backdropFilter: 'blur(10px)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.02)',
                  borderColor: '#1E90FF',
                  boxShadow: '0px 12px 30px rgba(30,144,255,0.3)',
                },
              }}
            >
              <FaCogs size={100} color="#1E90FF" />
              <Typography
                variant="h6"
                sx={{
                  mt: 3,
                  fontWeight: 600,
                  fontSize: '1.2rem',
                  letterSpacing: 2,
                  textTransform: 'uppercase',
                  color: '#ffffff',
                }}
              >
                Generative AI
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  mt: 2,
                  color: '#cccccc',
                  fontSize: '0.95rem',
                  letterSpacing: 1,
                }}
              >
                Different AI models and systems serve various applications. From large to small models, all contribute uniquely. A semantic AI layer on top enhances contextual understanding and insights.
              </Typography>
            </Box>
          </motion.div>
        </Grid>

        {/* AI Agents */}
        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <Box
              sx={{
                background: 'rgba(255, 255, 255, 0.04)',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: '16px',
                padding: theme.spacing(5),
                textAlign: 'center',
                backdropFilter: 'blur(10px)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.02)',
                  borderColor: '#1E90FF',
                  boxShadow: '0px 12px 30px rgba(30,144,255,0.3)',
                },
              }}
            >
              <AiOutlineRobot size={100} color="#1E90FF" />
              <Typography
                variant="h6"
                sx={{
                  mt: 3,
                  fontWeight: 600,
                  fontSize: '1.2rem',
                  letterSpacing: 2,
                  textTransform: 'uppercase',
                  color: '#ffffff',
                }}
              >
                AI Agents & Assistants
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  mt: 2,
                  color: '#cccccc',
                  fontSize: '0.95rem',
                  letterSpacing: 1,
                }}
              >
                Elevate your work and personal life with finely tuned AI agents and personalized assistants—designed for specific subjects and optimized for user satisfaction and performance.
              </Typography>
            </Box>
          </motion.div>
        </Grid>
      </Grid>

      {/* CTA Button */}
      {/* <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.5 }}
        viewport={{ once: true }}
      >
        <Button
          variant="contained"
          sx={{
            mt: 6,
            background: 'linear-gradient(135deg, #1E90FF, #00C9FF)',
            color: '#fff',
            padding: '12px 28px',
            borderRadius: '30px',
            fontWeight: 'bold',
            fontSize: '1rem',
            letterSpacing: 1,
            textTransform: 'uppercase',
            boxShadow: '0px 4px 20px rgba(0,0,0,0.4)',
            transition: 'all 0.3s ease',
            '&:hover': {
              background: 'linear-gradient(135deg, #00BFFF, #00E5FF)',
              boxShadow: '0px 6px 30px rgba(0,0,0,0.5)',
            },
          }}
          onClick={() => window.open('/ai-details', '_blank')}
        >
          Explore More AI Features
        </Button>
      </motion.div> */}
    </Box>









           <Box
      id="announcements"
      sx={{
        backgroundColor: '#000000',
        minHeight: '30vh',
        py: 8,
        px: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {/* Heading */}
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
       <Typography
  variant="h4"
  sx={{
    color: '#fff',
    mb: 4,
    fontWeight: 600,
    textAlign: 'center',
    letterSpacing: 6,
    textTransform: 'uppercase',
    fontSize: {
      xs: '1.4rem',  // small phones
      sm: '1.5rem',    // tablets
      md: '2rem',  // small laptops
      lg: '2rem',    // desktops
      xl: '2rem',  // large screens
    },
    '&:hover': {
      color: '#1E90FF',
    },
  }}
>
  Announcements
</Typography>

      </motion.div>

      {/* Cards Grid */}
      <Grid container spacing={4} justifyContent="center">
        {announcements.map((announcement, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <Card
                sx={{
                  background: 'rgba(255,255,255,0.05)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  backdropFilter: 'blur(12px)',
                  color: '#ffffff',
                  borderRadius: '16px',
                  boxShadow: '0px 8px 24px rgba(0,0,0,0.4)',
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    borderColor: '#1E90FF',
                    boxShadow: '0px 12px 40px rgba(30,144,255,0.3)',
                  },
                }}
              >
                <CardContent>
                  <Typography
                    variant="h6"
                    sx={{
                      textAlign: 'center',
                      mb: 2,
                      fontWeight: 600,
                      textTransform: 'uppercase',
                      letterSpacing: 2,
                      transition: 'color 0.3s',
                      '&:hover': {
                        color: '#1E90FF',
                      },
                    }}
                  >
                    {announcement.title}
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      color: '#cccccc',
                      letterSpacing: 1,
                      fontSize: '0.95rem',
                      mb: 2,
                    }}
                  >
                    {announcement.message}
                  </Typography>

                  {expandedIndex === index && (
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#bbbbbb',
                        fontSize: '0.9rem',
                        letterSpacing: 1,
                        mb: 2,
                      }}
                    >
                      {announcement.fullMessage}
                    </Typography>
                  )}

                  <Button
                    variant="contained"
                    onClick={() => handleToggleExpand(index)}
                    sx={{
                      mt: 1,
                      background: 'linear-gradient(135deg, #1E90FF, #00C9FF)',
                      color: '#fff',
                      textTransform: 'none',
                      fontWeight: 600,
                      borderRadius: '30px',
                      px: 3,
                      py: 1,
                      fontSize: '0.85rem',
                      letterSpacing: 1,
                      boxShadow: '0px 4px 20px rgba(0,0,0,0.4)',
                      '&:hover': {
                        background: 'linear-gradient(135deg, #00BFFF, #00E5FF)',
                        boxShadow: '0px 6px 30px rgba(0,0,0,0.5)',
                      },
                    }}
                  >
                    {expandedIndex === index ? 'Read Less' : 'Read More'}
                  </Button>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>

            <FuturePage />


            <NewsletterSection />


            <Box
      id="community"
      sx={{
        padding: theme.spacing(6),
        backgroundColor: '#000000',
        borderRadius: '16px',
        mb: theme.spacing(25),
        boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.5)',
      }}
    >
      {/* Section Heading */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            color: '#fff',
            textAlign: 'center',
            mb: 5,
            textTransform: 'uppercase',
            letterSpacing: 6,
            '&:hover': {
              color: '#1E90FF',
            },
          }}
        >
          Join Our Community
        </Typography>
      </motion.div>

      <Grid container spacing={5} justifyContent="center" alignItems="stretch">
        {/* Discord Card */}
        <Grid item xs={12} sm={6}>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <Card
              sx={{
                background: 'linear-gradient(145deg, #7289DA, #99aab5)',
                color: 'white',
                borderRadius: '16px',
                boxShadow: '0px 10px 30px rgba(0,0,0,0.4)',
                padding: theme.spacing(4),
                textAlign: 'center',
                transition: 'transform 0.3s',
                '&:hover': {
                  transform: 'scale(1.03)',
                },
              }}
            >
              <CardContent>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 600,
                    letterSpacing: 2,
                    mb: 2,
                    textTransform: 'uppercase',
                  }}
                >
                  Discord
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    color: '#ffffffcc',
                    fontWeight: 400,
                    mb: 4,
                    lineHeight: 1.7,
                    letterSpacing: 0.5,
                  }}
                >
                  Stay connected, share ideas, ask questions, and engage with fellow members. Join us on Discord to grow together!
                </Typography>

                <Button
                  variant="contained"
                  href={discordInviteURL}
                  target="_blank"
                  startIcon={<FaDiscord />}
                  sx={{
                    background: '#23272A',
                    color: '#fff',
                    padding: theme.spacing(1.5, 5),
                    fontSize: '1rem',
                    fontWeight: 600,
                    borderRadius: '30px',
                    textTransform: 'none',
                    boxShadow: '0px 4px 20px rgba(0,0,0,0.4)',
                    '&:hover': {
                      background: '#1E90FF',
                      boxShadow: '0px 6px 25px rgba(30,144,255,0.5)',
                    },
                  }}
                >
                  Join Now
                </Button>
              </CardContent>
            </Card>
          </motion.div>
        </Grid>

        {/* Why Join Section */}
        <Grid item xs={12} sm={6}>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <Box
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                border: '1px solid rgba(255,255,255,0.1)',
                backdropFilter: 'blur(12px)',
                borderRadius: '16px',
                padding: theme.spacing(4),
                color: '#fff',
                height: '100%',
                boxShadow: '0px 8px 24px rgba(0,0,0,0.3)',
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  mb: 3,
                  letterSpacing: 2,
                }}
              >
                Why Join?
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: '#bbbbbb',
                  fontSize: '1rem',
                  lineHeight: 1.8,
                  letterSpacing: 0.5,
                }}
              >
                • Participate in exclusive discussions and community events.<br />
                • Get help and support from knowledgeable members.<br />
                • Be the first to receive important updates and product news.<br />
                • Grow with a vibrant network of creators and innovators.
              </Typography>
            </Box>
          </motion.div>
        </Grid>
      </Grid>
    </Box>



            <Tooltip title="Scroll to Top" placement="top">

                <IconButton
                    onClick={scrollToTop}
                    sx={{
                        position: 'fixed', bottom: 16, right: 16, backgroundColor: 'white', color: 'black',
                        "&:hover": {
                            color: "#1E90FF",  // Icon color on hover
                        },
                    }}>
                    <ArrowUpwardIcon />
                </IconButton></Tooltip>




            <Footer />
        </div >
    );
}

export default Home;
